export default "__VITE_ASSET__ByjuV0T3__"